import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.css';
import App from './screens/App/App';
import Dashboard from './screens/Dashboard';
import Nfs from './screens/Fiscal/Nfs';
import ConsultaMovimento from './screens/Fiscal/ConsultaMovimento';
import Reprocessar from './screens/Fiscal/Reprocessar';
import Cadastrar from './screens/Fiscal/Cadastrar';
import Sucesso from './screens/Sucesso';
import Termos from './screens/Termos';
import Checkout from './screens/Checkout';
import CadastrarPagamento from './screens/Checkout/cadastrar';
import EPrescription from './screens/EPrescription';
import { init } from '@rematch/core';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import * as models from './models'

const store = init({ models})

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Route exact path="/"  component = {App}/>
      <Route exact path="/dashboard" component = {Dashboard}/>
      <Route exact path="/nfs" component = {Nfs}/>
      <Route exact path="/consultamovimento" component = {ConsultaMovimento}/>
      <Route exact path="/cadastrar" component = {Cadastrar}/>
      <Route exact path="/reprocessar" component = {Reprocessar}/>
      <Route exact path="/sucesso" component = {Sucesso}/>
      <Route exact path="/termos" component = {Termos}/>
      <Route exact path="/checkout" component = {Checkout}/>
      <Route exact path="/checkout/cadastrar" component = {CadastrarPagamento}/>
      <Route exact path="/eprescription" component = {EPrescription}/>
    </Router>
    </Provider>,
  document.getElementById('root')
);

reportWebVitals();
